import { PlatformType } from 'components/buttons/DownloadAppButton';

export const GaAppLink = {
  [PlatformType.APP_STORE]: 'https://apps.apple.com/us/app/google-authenticator/id388497605',
  [PlatformType.GOOGLE_PLAY]: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
};
